export const MARKERS_CONTEXT_MENU_SHOW = 'MARKERS_CONTEXT_MENU_SHOW';
export const MARKERS_CONTEXT_MENU_HIDE = 'MARKERS_CONTEXT_MENU_HIDE';
